const loadedLibraries = new Set<string>();

export const loadGapiLibrary = (apiName: string): Promise<void> => {
  return new Promise((resolve, reject) => {
    if (loadedLibraries.has(apiName)) {
      resolve();
    }

    window.gapi.load(apiName, {
      callback: () => {
        loadedLibraries.add(apiName);
        resolve();
      },
      onerror: (e: unknown) => {
        reject(e);
      },
    });
  });
};
